
import Hero from "./Hero";
import CreateTicket from "./CreateTicket.js"

function SupportPage() {
    return ( 
        <div>
             <Hero />
            <CreateTicket />
           
        </div>
     );
}

export default SupportPage;